import { render } from "./AppBar.vue?vue&type=template&id=0a273c2c&scoped=true"
import script from "./AppBar.vue?vue&type=script&lang=js"
export * from "./AppBar.vue?vue&type=script&lang=js"

import "./AppBar.vue?vue&type=style&index=0&id=0a273c2c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\47959\\OneDrive\\Documents\\GitHub\\Poesiparken\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a273c2c"]])

export default __exports__